import { render, staticRenderFns } from "./JVxeDepartSelectCell.vue?vue&type=template&id=51cec618&scoped=true"
import script from "./JVxeDepartSelectCell.vue?vue&type=script&lang=js"
export * from "./JVxeDepartSelectCell.vue?vue&type=script&lang=js"
import style0 from "./JVxeDepartSelectCell.vue?vue&type=style&index=0&id=51cec618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cec618",
  null
  
)

export default component.exports